import TrialLessonsList from './TrialLessonsList';

export default TrialLessonsList;
